export default __webpack_public_path__ + "static/media/Group_7473.bf5b5d62.png";